import { Speaker } from "@/lib/events";
import { useLang } from "@/i18n";
import { UserRound } from "lucide-react";

export const SpeakerList = ({ speakers }: { speakers: Speaker[] }) => {
  const lang = useLang();
  if (!speakers.length) return null;
  return (
    <section className="mb-8">
      <h2 className="text-sm font-medium text-primary uppercase tracking-wider mb-3">
        {lang === "en" ? (speakers.length > 1 ? "Guest speakers" : "Guest speaker") : speakers.length > 1 ? "Gastvortragende" : "Gastvortrag"}
      </h2>
      <div className="grid gap-4 sm:grid-cols-2">
        {speakers.map((sp, i) => (
          <div key={i} className="flex gap-4 rounded-2xl border border-border bg-card p-4">
            {sp.photo_url ? (
              <img src={sp.photo_url} alt={sp.name} loading="lazy" className="w-16 h-16 rounded-full object-cover shrink-0" />
            ) : (
              <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center shrink-0">
                <UserRound className="w-7 h-7 text-muted-foreground" />
              </div>
            )}
            <div>
              <p className="font-semibold text-foreground">{`${sp.title} ${sp.name}`.trim()}</p>
              {sp.specialty && <p className="text-sm text-primary">{(lang === "en" && sp.specialty_en) || sp.specialty}</p>}
              {((lang === "en" && sp.bio_en) || sp.bio) && (
                <p className="text-sm text-muted-foreground mt-1">{(lang === "en" && sp.bio_en) || sp.bio}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
